module.exports = __webpack_public_path__ + "static/media/TRIAL1-answered-after-10-sec.8f7d86ba.mp3";